import { PRODUCT_NAME_LABEL } from '@/phrase/ProductNameLabels.ts';
import { SUPPORTED_UNIT_LABEL_LONG } from '@/phrase/SupportedUnitLabels';

export const PRODUCT_CARD_NAME_LABEL = {
    ...PRODUCT_NAME_LABEL,
    CUSTOM_SERVICE: 'productTemplate.serviceMaterial',
    CUSTOM_SERVICE_TRANSPORT: 'productTemplate.serviceTransport',
} as const;

export const DISPOSAL_PURPOSE_LABEL = {
    RECYCLING: 'productTemplateGroup.description.recycling',
    DISPOSAL: 'productTemplateGroup.description.disposal',
} as const;

export const TRANSPORT_UNIT_LABEL = {
    ...SUPPORTED_UNIT_LABEL_LONG,
    HOUR: 'productTemplate.billedPerHour',
    TON: 'productTemplate.billedPerTon',
    TRANSPORT: 'productTemplate.flatrate',
} as const;
